module.exports = __webpack_public_path__ + "static/spring_eladrin-c41997907a855ed61b91c425151bc14e.png";